export const SEEN_TOURS = `
query seenTours {
  seenTours {
    __typename
    ... on SeenTours {
      seenTours
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

export const GET_SEEN_TOUR_BY_ID_AND_USER_ID = `
query getSeenTourByIdAndUserId($tour_id: Int!, $user_id: Int!) {
  getSeenTourByIdAndUserId(tour_id: $tour_id, user_id: $user_id) {
    __typename
    ... on SeenTourUser {
      tour_id,
      user_id,
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;

